var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSquareLogo = function SvgIconSquareLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.75 19.25V4.75h14.5v14.5zM4.5 2.75A1.75 1.75 0 0 0 2.75 4.5v15c0 .966.784 1.75 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75v-15a1.75 1.75 0 0 0-1.75-1.75zM9 8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm1 6v-4h4v4z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSquareLogo;